import type { TenantRole } from "../auth-service/contract";

/**
 * PRODUCT_DEV-1332: テナントの役割の呼び名の正本（画面・データ出力・API で同じ呼び名を出す）。
 * 値の正本は `auth-service/contract` の `TENANT_ROLES`。呼び名は 2026-10-29 に決めた画面のもの
 * （管理者 → 管理ユーザー、間にパワーユーザーを足した・PRODUCT_DEV-1235）。
 */
export const TENANT_ROLE_LABELS: Readonly<Record<TenantRole, string>> = {
  viewer: "閲覧者",
  member: "メンバー",
  power: "パワーユーザー",
  admin: "管理ユーザー",
};

/** 役割の呼び名。知らない値は `fallback`（既定はメンバー。古い画面が新しい値を受け取ったときと同じ倒し方） */
export const tenantRoleLabel = (role: string | undefined, fallback = TENANT_ROLE_LABELS.member): string =>
  (TENANT_ROLE_LABELS as Readonly<Record<string, string>>)[role ?? ""] ?? fallback;
